import { render } from "./ImageGrid.vue?vue&type=template&id=7ceff997&scoped=true"
import script from "./ImageGrid.vue?vue&type=script&lang=js"
export * from "./ImageGrid.vue?vue&type=script&lang=js"

import "./ImageGrid.vue?vue&type=style&index=0&id=7ceff997&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src76281229/src/git-codecommit.us-east-1.amazonaws.com/v1/repos/www-uga-edu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ceff997"]])

export default __exports__